import React, {useEffect} from 'react';
import type {DataLoadStatus} from 'api/types';
import type {Collection} from 'services/series/types';
import {useLazyGetSeriesQuery} from 'services/series/seriesApi';
import type {BulkUpdate} from '../types';
import {useGetBulkUpdateQuery} from '../bulkUpdatesApi';
import {getIdsFromAction} from '../functions/getIdsFromAction';
import {mapBulkUpdateDto} from '../mappers';

export const useBulkUpdate = (id: string): DataLoadStatus<BulkUpdate> => {
  const {data, isFetching: bulkUpdateIsFetching} = useGetBulkUpdateQuery({id});
  const [getSeries, {isFetching: collectionsIsFetching}] =
    useLazyGetSeriesQuery();

  const [collections, setCollections] = React.useState<Collection[]>([]);

  // Load collections if series relations.
  useEffect(() => {
    if (data) {
      if (data.field.field === 'seriesRelations') {
        const collectionIds = getIdsFromAction(data.action);

        collectionIds.forEach(id => {
          getSeries({id})
            .unwrap()
            .then(collection => {
              setCollections(prev => [...prev, collection]);
            });
        });
      }
    }
  }, [data, getSeries]);

  if (bulkUpdateIsFetching || collectionsIsFetching) {
    return {
      status: 'Loading',
    };
  }

  if (data) {
    return {
      status: 'Loaded',
      data: mapBulkUpdateDto(id, data, collections),
    };
  }

  return {status: 'NotLoaded'};
};
